import React, { useEffect, useState } from 'react'
import { actionPermission, errorSchema, utils } from 'helper'
import { CityDropdownForTrip, CommonModal, CustomSelect } from 'components'
import StorageService from 'utils/StorageServices/StorageServices'
import { getConsignorDropdownListData } from '_services/dropdownServices/dropdownService'
import { fetchConsignorDetailsData, getConsignorListData } from '_services/accountsServices/consignorServices'
import EbillExtentionModal from 'modals/EbillExtentionModal'
import { constant } from 'constants/constant';
import toast from 'react-hot-toast'
import { getCityLocationList } from '_services/accountsServices/cityLocationService'
import AddLocationModal from 'modals/AddLocationModal'

const formObj = {
    party: {},
}

const formObjLocation = {

    from_city: {},
    to_city: {},
}

const AddLrModal = (props) => {
    let { nextModal, closeModal, addButtonAction, showPrefield, secondSubmit, isAddLrLater, filledLocation = {}, submitTitle, branchFirmIdForTrip = {} } = props;

    const [formValue, setFormValue] = useState(formObj);
    const [formError, setFormError] = useState({});
    const [loading, setLoading] = useState(false);
    const [consignorList, setConsignorList] = useState([]);
    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        messageType: null,
        templateId: null,
        templateData: {}
    });

    const [formValueLocation, setFormValueLocation] = useState(formObjLocation);
    const [formErrorLocation, setFormErrorLocation] = useState({});
    const [loadingLoaction, setLoadingLocation] = useState(false);
    const [openLoction, setOpenLoction] = useState(false)
    const [typeOfDropdown, setTypeOfDropdown] = useState({
        type: "",
        index1: '',
        index: ""
    })

    const getDropdownDataConsignorList = async () => {
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                firm_id: branchFirmIdForTrip?._id ? branchFirmIdForTrip?._id : StorageService.getFirmId(),
                limit: 100,
                offset: 1,
                search: '',
            }
            const res = await getConsignorDropdownListData(object);
            setLoading(false);
            if (res?.responseCode == 200) {
                setConsignorList(res?.data?.consignor_list)
            }
        } catch (error) {
            // throw error;
        }
    }

    const fetchConsignor = async (search, page, limit) => {
        setLoading(true);
        const res = await getConsignorListData({
            company_id: StorageService.getCompanyId(),
            firm_id: branchFirmIdForTrip?._id ? branchFirmIdForTrip?._id : StorageService.getFirmId(),
            offset: page,
            limit,
            search,
        });

        if (res?.responseCode === 200) {

            const list = await res?.data?.consignor_list?.map((el) => ({
                ...el, label: el?.name,
                value: el?._id,
                consignor_code: el?.consignor_code,
                template_no: el?.template_no,
            }))

            if (list.length == 1) {
                setFormValue((f) => ({ ...f, party: list[0] }))
            }

            setLoading(false);
            return {
                items: list,
                total: res?.data?.total_record,
            };

        } else {
            setLoading(false);
            toast.error(res?.responseMessage);
        }
    };

    const fetchFromCity = async (search, page, limit) => {
        const res = await getCityLocationList({
            countryCode: "IN",
            stateCode: "",
            offset: page,
            limit,
            search,

        });
        if (res?.responseCode === 200) {
            const list = res?.data?.all_cities.map((c) => ({ ...c, _id: c.name, label: `${c.name}, ${c.stateName}` }))

            return {
                items: list,
                total: res?.data?.total_record,
            };
        } else {
            toast.error(res?.responseMessage);
        }
    };

    const validateForm = () => {
        const errors = {};

        // Validate from_city
        if (!formValueLocation?.from_city?.value) {
            errors.from_city = "Please select pickup location";
        }

        // Validate to_city
        if (!formValueLocation?.to_city?.value) {
            errors.to_city = "Please select drop location";
        }



        return errors;
    };


    useEffect(() => {
        setLoading(true);
        getDropdownDataConsignorList();
    }, [])

    const onhandleSelect = async (item, name) => {
        const stateObj = { ...formValue, [name]: item };
        setFormValue(stateObj);

        if (!utils.isObjectKeyEmpty(formError)) {
            const validationResult = await utils.checkFormError(stateObj, errorSchema.createLrModalSchema);
            if (validationResult === true) {
                setFormError({});
            } else {
                setFormError(validationResult);
            }
        }
    };

    const apiCallingFunction = async () => {
        try {
            let object = {
                consignor_id: formValue?.party?.value,
                company_id: StorageService.getCompanyId(),
            };

            const res = await fetchConsignorDetailsData(object);

            if (res) {

                let modalData;

                if (submitTitle === "Add more Details") {
                    // special condition
                    modalData = {
                        ...res?.data?.consignor,
                        ...formValueLocation
                    };
                } else {
                    // normal flow (old behaviour)
                    modalData = res?.data?.consignor;
                }

                nextModal(modalData);
                closeModal(false);

                setFormValue({});
                setLoading(false);
            } else {
                setLoading(false);
            }

        } catch (error) {
            setLoading(false);
        }
    };

    const handlePermissionCall = async (e) => {
        e.preventDefault();

        const validationErrors = validateForm();
        const validationResult = await utils?.checkFormError(
            formValue,
            errorSchema.createLrModalSchema
        );

        const isSchemaValid = utils?.isObjectKeyEmpty(validationResult);
        const isLocationValid =
            submitTitle === "Add more Details"
                ? Object.keys(validationErrors).length === 0
                : true;

        if (isSchemaValid && isLocationValid) {
            await actionPermission({
                company_id: StorageService.getCompanyId(),
                type: constant?.USABILITY_CONFIG_TYPES?.LR,
                onSuccess: () => handleSubmit(e),
                setModalConfig
            });
        } else {
            setFormError(validationResult);
            if (submitTitle === "Add more Details") {
                setFormErrorLocation(validationErrors);
            }
        }
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const validationErrors = validateForm();
        const validationResult = await utils?.checkFormError(
            formValue,
            errorSchema.createLrModalSchema
        );

        const hasSchemaErrors = !utils?.isObjectKeyEmpty(validationResult);

        // validationErrors only when submitTitle is "Add more Details"
        const hasValidationErrors =
            submitTitle === "Add more Details"
                ? Object.keys(validationErrors).length > 0
                : false;

        if (hasSchemaErrors || hasValidationErrors) {
            setFormError(validationResult);

            if (submitTitle === "Add more Details") {
                setFormErrorLocation(validationErrors);
            }

            return;
        }

        try {
            setLoading(true);
            await apiCallingFunction();
            setFormError("");
        } catch (error) {
            console.error("Submission failed:", error);
            setFormError("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitWithOutLr = async (event) => {
        event.preventDefault();

        const validationErrors = validateForm();
        const validationResult = await utils?.checkFormError(
            formValue,
            errorSchema.createLrModalSchema
        );

        const hasSchemaErrors = !utils?.isObjectKeyEmpty(validationResult);
        const hasValidationErrors =
            submitTitle === "Add more Details"
                ? Object.keys(validationErrors).length > 0
                : false;

        if (hasSchemaErrors || hasValidationErrors) {
            setFormError(validationResult);

            if (submitTitle === "Add more Details") {
                setFormErrorLocation(validationErrors);
            }

            setLoading(false);
            return;
        }

        let modalData;

        if (submitTitle === "Add more Details") {
            // special condition
            modalData = {
                formValue,
                formValueLocation
            };

        } else {
            // normal flow (old behaviour)
            modalData = formValue;
        }

        secondSubmit(modalData);
    };


    const propsLrModalInhance = {
        ...props,
        isLoadding: loading,
        disabled: loading,
        onSubmit: (e) => submitTitle == "Select LR" ? handleSubmit(e) : handlePermissionCall(e),
        secondSubmit: props?.modalTitle != "Edit LR" ? handleSubmitWithOutLr : false,
        isAddLrLater: isAddLrLater,
        filledLocation: filledLocation
    }

    // const propsLrModalInhance = {
    //     ...props,
    //     isLoadding: loading,
    //     disabled: loading,
    //     onSubmit: props?.modalTitle !== "Edit LR" ? handleSubmitWithOutLr : false,
    //     secondSubmit: (e) =>
    //         submitTitle === "Select LR" ? handleSubmit(e) : handlePermissionCall(e),
    //     isAddLrLater,
    //     filledLocation,
    // };

    useEffect(() => {
        if (consignorList?.length > 0 && showPrefield) {
            setFormValue((s) => ({
                ...s,
                party: consignorList?.map((el) => {
                    return {
                        label: el?.name,
                        value: el?._id,
                    }
                })[0],
            }))
        }
    }, [consignorList, showPrefield])

    const buttonActionHandler = () => {
        addButtonAction(true);
        closeModal(false)
    }

    const addNewItemHandler = (e, type) => {

        setOpenLoction(true)
        setTypeOfDropdown((i) => ({
            ...i,
            type,

        }))

        // setModalZIndex(999)
    }

    const handleInputChange = (data, key) => {
        setFormValueLocation((s) => ({
            ...s,
            [key]: {
                ...data,
                label: data?.label,
                value: data?._id,
            }
        }))
        setFormErrorLocation((s) => ({
            ...s,
            [key]: "",
        }))
    }


    const callBackDataMap = async (data) => {
        if (!typeOfDropdown?.type) return;

        const { type, index1 } = typeOfDropdown;

        // Format the selected city data
        const formattedData = {
            ...data,
            _id: data.name, // or use a better unique ID if available
            label: `${data.name}, ${data.stateName}`,
            value: data.name
        };


        setFormValueLocation((s) => ({
            ...s,
            [type]: formattedData
        }))
        setFormErrorLocation((s) => ({
            ...s,
            [type]: "",
        }))

    };


    let ebillExpProps = {
        isOpen: modalConfig.isOpen,
        closeModal: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
        onSubmit: (e) => setModalConfig(prev => ({ ...prev, isOpen: false })),
        modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
        headerPart: true,
        floatCrossBtn: true,
        submitTitle: "Send Enquiry",
        messageType: modalConfig.messageType,
        templateId: modalConfig.templateId,
        templateData: modalConfig.templateData
    };

    let gmapLocate = {
        isOpen: openLoction,
        closeModal: (e) => {
            setOpenLoction(false)

        },
        modalMainClass: "_dashCommon_Modal _mdModalLoction",
        modalTitle: 'Add Location',
        submitTitle: 'Add Location',
        callBackDataMap: callBackDataMap
    };

    return (
        <div>
            <CommonModal {...propsLrModalInhance}>
                <div className='addLr_body'>
                    <CityDropdownForTrip
                        label={"Select Party"}
                        placeholder="Select Party"
                        fetchData={fetchConsignor}
                        pageSize={20}
                        onChange={(data) => {
                            onhandleSelect(data, 'party')
                        }}
                        selectedItem={formValue?.party?.value ? formValue?.party : {}}
                        error={formError["party.label"]}
                        errorMessage={formError["party.label"]}
                        isClearOption={formValue?.party?.value ? true : false}
                        isClearHandleChange={() => {
                            onhandleSelect({}, "party"); // label: 'Assign Driver', value: ''
                        }}
                        isAddButton={true}
                        addButtonAction={(e) => buttonActionHandler(e)}
                    />
                </div>
                {submitTitle == "Add more Details" && <div className='addLr_body' style={{ display: "flex", flexDirection: "column", gap: "15px", paddingTop: 0 }}>
                    <p style={{ fontSize: "14px", fontWeight: 500, marginBottom: 0 }}>Select Location</p>

                    <CityDropdownForTrip
                        key={`fromLoction`}
                        label="From City * "
                        placeholder="Select a city"
                        fetchData={fetchFromCity}
                        isAddButton={true}
                        //   addButtonAction={(e) => addNewItemHandler(e, "from", index1, "")}
                        pageSize={20}
                        onChange={(data) => handleInputChange(data, "from_city")}
                        selectedItem={formValueLocation?.from_city}
                        error={!!formErrorLocation.from_city}
                        errorMessage={formErrorLocation.from_city}
                        addButtonAction={(e) => addNewItemHandler(e, "from_city")}
                    />
                    <CityDropdownForTrip
                        key={`toLoction`}
                        label="To City * "
                        placeholder="Select a city"
                        fetchData={fetchFromCity}
                        isAddButton={true}
                        addButtonAction={(e) => addNewItemHandler(e, "to_city")}
                        onChange={(data) => handleInputChange(data, "to_city")}
                        selectedItem={formValueLocation?.to_city}
                        error={!!formErrorLocation.to_city}
                        errorMessage={formErrorLocation.to_city}

                    />
                </div>}
            </CommonModal>

            {modalConfig.isOpen && <EbillExtentionModal

                {...ebillExpProps}

            />}

            {openLoction && <AddLocationModal {...gmapLocate} />}


        </div>
    )
}

export default AddLrModal
